module.exports = __webpack_public_path__ + "static/Netwrix-25af6a9c63dff21e30c92efecebdd946.jpg";